import React, { useState } from 'react';
import styled from 'styled-components';

/**
 * Botón de ver/ocultar contraseña, con el mismo aspecto que ya usaba el modal de
 * acceso (AccesoIconoModal). Se usa con una función como hijo, que recibe el
 * `type` del input, para que cada formulario conserve su propio campo y estilo:
 *
 *   <VerContrasena>{tipo => <Input type={tipo} ... />}</VerContrasena>
 *
 * Por defecto el botón se coloca como hermano del input, lo que encaja cuando el
 * borde lo dibuja un contenedor en flex. Con `flotante` se superpone al campo,
 * para los inputs que llevan su propio borde y ocupan todo el ancho.
 */

const SV = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.7,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': 'true',
};

export const IconoOjo = ({ tachado }) => (
  <svg {...SV}>
    <path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Z" />
    <circle cx="12" cy="12" r="3" />
    {tachado && <path d="M4 4l16 16" />}
  </svg>
);

const Fila = styled.div`
  display: flex;
  align-items: center;
  ${p => p.$flotante
    ? 'position: relative; width: 100%;'
    : 'flex: 1; min-width: 0;'}
  /* Con el botón encima, el texto no debe pasar por debajo del icono. */
  ${p => p.$flotante ? '&& > * { padding-right: 42px; }' : ''}
`;

const Boton = styled.button`
  flex: none;
  display: grid;
  place-items: center;
  padding: 6px 10px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: ${p => p.$color || '#9aa6b8'};
  font: inherit;
  cursor: pointer;
  opacity: 0.75;
  &:hover { opacity: 1; }
  &:focus-visible { outline: 2px solid currentColor; outline-offset: 1px; }
  svg { width: 19px; height: 19px; display: block; }
  ${p => p.$flotante
    ? 'position: absolute; right: 4px; top: 50%; transform: translateY(-50%);'
    : ''}
`;

const VerContrasena = ({ children, color, flotante = false, className }) => {
  const [ver, setVer] = useState(false);
  return (
    <Fila $flotante={flotante} className={className}>
      {children(ver ? 'text' : 'password')}
      <Boton
        type="button"
        onClick={() => setVer(v => !v)}
        aria-pressed={ver}
        aria-label={ver ? 'Ocultar contraseña' : 'Mostrar contraseña'}
        title={ver ? 'Ocultar' : 'Mostrar'}
        $color={color}
        $flotante={flotante}
      >
        <IconoOjo tachado={ver} />
      </Boton>
    </Fila>
  );
};

export default VerContrasena;
